import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
    DO_NOTHING,
    FlyFreelyError,
    FlyFreelyLoggingService,
    PreferencesService
} from '@flyfreely-portal-ui/flyfreely';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'data-privacy-banner',
    templateUrl: './data-privacy-banner.component.html',
    styleUrl: './data-privacy-banner.component.scss'
})
export class DataPrivacyBannerComponent {
    form = new FormGroup({
        allowSentry: new FormControl(true),
        allowMixpanel: new FormControl(false)
    });

    private ngUnsubscribe$ = new Subject<void>();

    constructor(
        private preferencesService: PreferencesService,
        private logging: FlyFreelyLoggingService
    ) {}

    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    updateUserPrivacySettings() {
        const options = this.form.value;
        this.preferencesService
            .setDataPreferences(
                options.allowSentry ?? false,
                options.allowMixpanel ?? false
            )
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: DO_NOTHING,
                error: (error: FlyFreelyError) => {
                    this.logging.error(
                        error,
                        `Error while updating privacy settings: ${error.message}`
                    );
                }
            });
    }
}
